/**
 * ACT2-1124: Copy on an account of a readable workspace in Settings › Accounts. It copies the account into this
 * workspace (`accountCopies.pick`), and the copy then is one of this workspace's own accounts.
 */
import { Copy } from 'lucide-react';

import { ActionTooltip } from '@/_shared/components/ActionTooltip';
import { Button } from '@/_shared/components/ui/button';

import type { OrganizationAccountListRow } from '../../lib/accountList';
import { useAccountCopyContext } from './accountCopyContext';

/** One copy at a time. */
const ANOTHER_COPY_RUNNING = 'Wait until Lookout finishes copying the other account.';

export function CopyAccountButton({ row }: { row: OrganizationAccountListRow }): React.ReactElement {
  const { pick, blockedReason } = useAccountCopyContext();
  const { accountId, workspaceName } = row.option;
  const blocked =
    blockedReason ?? (pick.pickingId !== null && pick.pickingId !== accountId ? ANOTHER_COPY_RUNNING : null);
  return (
    <ActionTooltip show={blocked !== null} message={blocked ?? ''}>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        label="Copy"
        aria-label={`Copy ${row.name} from ${workspaceName}`}
        Icon={<Copy />}
        loading={pick.pickingId === accountId}
        disabled={blocked !== null}
        onClick={() => pick.copy(accountId, row.name)}
      />
    </ActionTooltip>
  );
}
